const CauditActions = require("../../actions/metadata/CauditActions.js");

const CauditData = require("../../types/metadata/CauditData.js");

function getUpdatedSpec(originalState, specUpdate) {
    const newSpecData = Object.assign({}, CauditData.GetSpecData(), specUpdate);

    const update = Object.assign({}, originalState.Metadata, {
        CurrentSpec: Object.assign({}, originalState.Metadata.CurrentSpec, {
            Data: newSpecData
        })
    });

    return Object.assign({}, originalState, {
        Metadata: update
    });
}

function getCurrentTargets(originalState) {
    return Object.assign({}, originalState.Metadata.CurrentSpec.Data.Targets);
}

const CauditReducers = {
    [CauditActions.LoadTargets](prev, action) {
        const result = getUpdatedSpec(prev, {
            Targets: {
                Loading: true,
                Loaded: false,
                Data: [],
                Error: null
            },
            Target: null
        });

        return result;
    },
    [CauditActions.LoadedTargets](prev, action) {
        const orderedData = action.Data;
            //.sort((a, b) => {
            //    if (a.DisplayOrder < b.DisplayOrder) return -1;
            //    if (a.DisplayOrder > b.DisplayOrder) return 1;

            //    if (a.GLCode < b.GLCode) return -1;
            //    if (a.GLCode > b.GLCode) return 1;

            //    return 1;
            //});

        const result = getUpdatedSpec(prev, {
            Targets: {
                Loading: false,
                Loaded: true,
                Data: orderedData,
                Error: null
            },
            Target: null
        });

        return result;
    },
    [CauditActions.LoadTargetsErrored](prev, action) {
        const result = getUpdatedSpec(prev, {
            Targets: {
                Loading: false,
                Loaded: false,
                Data: [],
                Error: action.Error
            },
            Target: null
        });

        return result;
    },
    [CauditActions.TargetSelected](prev, action) {
        const isComplete = action.Target && action.Target.length > 0;
        const arg = isComplete ? JSON.stringify({ "AuditID": action.Target }) : null;

        const newSpecData = Object.assign({}, CauditData.GetSpecData(), {
            Targets: getCurrentTargets(prev),
            Target: action.Target,
            IsComplete: isComplete,
            Arg: arg
        });

        const result = getUpdatedSpec(prev, newSpecData);

        return result;
    }
};

module.exports = CauditReducers;


// WEBPACK FOOTER //
// ./src/reducers/metadata/CauditReducers.js